var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1253_7039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1152 5.43677C24.1152 4.13052 23.0352 3.06177 21.7152 3.06177H2.51523C1.19523 3.06177 0.115234 4.13052 0.115234 5.43677V19.6868C0.115234 20.993 1.19523 22.0618 2.51523 22.0618H21.7152C23.0352 22.0618 24.1152 20.993 24.1152 19.6868V5.43677ZM21.7152 5.43677L12.1152 11.3743L2.51523 5.43677H21.7152ZM21.7152 19.6868H2.51523V7.81177L12.1152 13.7493L21.7152 7.81177V19.6868Z",
    fill: "url(#paint0_linear_1253_7039)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1253_7039",
    x1: 12.1208,
    y1: -6.38525,
    x2: 12.1208,
    y2: 26.2198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00902,
    stopColor: "#F6CD66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0391861,
    stopColor: "#DCAE4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0707524,
    stopColor: "#C8963B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1039,
    stopColor: "#B9852D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1397,
    stopColor: "#B17A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1829,
    stopColor: "#AE7723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3046,
    stopColor: "#CE9E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#E8BF61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4902,
    stopColor: "#F2CB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5439,
    stopColor: "#ECC466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6215,
    stopColor: "#DDB155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7132,
    stopColor: "#C3923A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#AE7723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8178,
    stopColor: "#B27C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8661,
    stopColor: "#BF8B33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9189,
    stopColor: "#D3A446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9745,
    stopColor: "#F0C660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1253_7039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 24.1152 0.561768)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.da1810ac1ef495edc544be757d709fe7.svg";
export { ForwardRef as ReactComponent };